import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Alert,
    CircularProgress,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function DeleteNotificationCampaignDialog({
    open,
    onClose,
    campaign,
    onConfirm,
}) {
    const [deleting, setDeleting] = useState(false);
    const [error, setError] = useState(null);

    if (!campaign) return null;

    const handleClose = (evt, reason) => {
        if (reason === 'backdropClick') return;
        setError(null);
        setDeleting(false);
        onClose?.(evt, reason);
    };

    const handleConfirm = async () => {
        setError(null);
        setDeleting(true);
        try {
            await onConfirm?.(campaign.id);
            handleClose();
        } catch (e) {
            const msg =
                e?.response?.data?.message ||
                e?.response?.data ||
                'Erro ao excluir a campanha.';
            setError(
                typeof msg === 'string' ? msg : 'Erro ao excluir a campanha.'
            );
            setDeleting(false);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth='xs' fullWidth>
            <DialogTitle>
                Excluir campanha
                <IconButton
                    aria-label='close'
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (t) => t.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: 1 }}>
                <Alert severity='warning' sx={{ mb: 2 }}>
                    Essa ação é irreversível. A campanha será removida
                    permanentemente.
                </Alert>

                <Typography variant='body2' sx={{ color: '#555' }}>
                    Tem certeza que deseja excluir a campanha?
                </Typography>

                {error && (
                    <Alert severity='error' sx={{ mt: 2 }}>
                        {error}
                    </Alert>
                )}
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                    variant='outlined'
                    disabled={deleting}
                >
                    Cancelar
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant='contained'
                    color='error'
                    disabled={deleting}
                    endIcon={deleting ? <CircularProgress size={18} /> : null}
                >
                    {deleting ? 'Excluindo...' : 'Excluir'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
